// Offline queue for pre-start checks submitted with no signal.
// Stored in localStorage and flushed automatically when back online.
import { api } from "@/lib/api";

const KEY = "ironlog_prestart_queue";

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

function setQueue(q) {
  try {
    localStorage.setItem(KEY, JSON.stringify(q));
  } catch {
    /* storage full — drop silently rather than crash */
  }
}

export function pendingCount() {
  return getQueue().length;
}

export function queuePreStart(machineId, payload) {
  const q = getQueue();
  q.push({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    machineId,
    payload,
    queuedAt: new Date().toISOString(),
  });
  setQueue(q);
  window.dispatchEvent(new Event("prestart-queue-changed"));
  return q.length;
}

let flushing = false;

// Attempts to submit every queued pre-start. Keeps items that fail due to
// network errors; drops items rejected by the server (4xx) so they can't loop forever.
export async function flushQueue() {
  if (flushing) return { synced: 0, remaining: pendingCount() };
  const q = getQueue();
  if (!q.length) return { synced: 0, remaining: 0 };

  flushing = true;
  let synced = 0;
  const remaining = [];
  try {
    for (const item of q) {
      try {
        await api.post(`/public/machines/${item.machineId}/prestart`, item.payload);
        synced += 1;
      } catch (err) {
        const status = err?.response?.status;
        if (status && status >= 400 && status < 500) {
          // Permanent failure (e.g. machine deleted) — drop it.
        } else {
          remaining.push(item); // network/5xx — keep for next time
        }
      }
    }
  } finally {
    setQueue(remaining);
    flushing = false;
    window.dispatchEvent(new Event("prestart-queue-changed"));
  }
  return { synced, remaining: remaining.length };
}
